import React from 'react';

import { api } from '../../../api';
import { isImageUrl } from '../../../util/url';

export const HeroBanner = () => {
  const { data: personalizationContent, isLoading: personalizationContentLoading } =
    api.personalization.personalizationContent.useQuery();

  if (
    personalizationContentLoading ||
    !personalizationContent?.heroBanner?.enabled ||
    !personalizationContent.heroBanner.imageUrl?.trim()
  ) {
    return null;
  }

  const bannerImageUrl = personalizationContent.heroBanner.imageUrl?.trim();
  const showBannerImage = Boolean(bannerImageUrl && isImageUrl(bannerImageUrl));
  const showMobileBannerImage = Boolean(
    personalizationContent.heroBanner.mobileImageUrl?.trim() &&
      isImageUrl(personalizationContent.heroBanner.mobileImageUrl?.trim())
  );

  const mobileSrc =
    personalizationContent.heroBanner.mobileImageUrl?.trim() && showMobileBannerImage
      ? personalizationContent.heroBanner.mobileImageUrl
      : bannerImageUrl;
  const hasLink = Boolean(personalizationContent.heroBanner.redirectUrl?.trim());

  const bannerImages = (
    <>
      {showBannerImage ? (
        <img
          src={bannerImageUrl}
          alt="hero banner"
          className="hidden w-full max-w-full rounded-lg shadow-md md:block"
        />
      ) : null}
      {mobileSrc ? (
        <img src={mobileSrc} alt="mobile hero banner" className="w-full max-w-full rounded-lg shadow-md md:hidden" />
      ) : null}
    </>
  );

  const content = <div className="container mx-auto">{bannerImages}</div>;

  if (!showBannerImage) {
    return null;
  }

  return (
    <div role="banner" aria-label="Hero banner" className="gap-[10px] bg-slate-1 p-10">
      {hasLink ? (
        <a
          href={personalizationContent.heroBanner.redirectUrl}
          className="text-inherit container mx-auto block no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
          aria-label="Hero banner"
          target="_blank"
          rel="noopener noreferrer"
        >
          {bannerImages}
        </a>
      ) : (
        content
      )}
    </div>
  );
};
